module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-114x114-a531c98f9b0fa16ed63ffb624b11406d.png";